export const LOCALSTORAGE_KEY_REFERRAL = "10A_Referral"
